export default "__VITE_ASSET__CpawNiJK__"